dealershipModule.factory("ProfitSetting", ['ProfitSettingTypes', function(ProfitSettingTypes) {
    var ProfitSetting = function() {
        this.type = ProfitSettingTypes.Flat;

        // the following are intended to be private, and should not be accessed directly.  Angular.js has a convention of using $$ prefix to indicate private members, however
        // doing so alters the semantics of the angular.equals function, in that it ignores $$ properties. This means that two ProfitSetting objects will be considered
        // equivalent if they are both of the same type, which is not what we want.
        this._profitAmount = 0;
        this._percentToCostCap = 0;
        this._percent = 0;
        this._maxProfit = 0;
        this._retailAmount = 0;
        this._vehicleOverridePurchasePrice = 0;
        this._vehicleOverrideEnabled = false;
        this._vehicleOverrideType = ProfitSettingTypes.Flat;
        this._vehicleOverrideProfitAmount = 0;
        this._vehicleOverridePercentToCostCap = 0;
        this._vehicleOverridePercent = 0;
        this._vehicleOverrideMaxProfit = 0;
        this._vehicleOverrideRetailAmount = 0;
    };

    ProfitSetting.prototype.convertForBusinessSvcs = function() {
        var convertedProfitSetting = new SPANProfitSetting();

        convertedProfitSetting.mapProfitAmountFieldsToSvc(this);
        convertedProfitSetting.ProfitMode = mapProfitSettingTypes(this.type);
        convertedProfitSetting.ProfitModeVehiclePriceOverride = mapProfitSettingTypes(this._vehicleOverrideType);
        convertedProfitSetting.Product = this.productData;

        return convertedProfitSetting;
    };

    function mapProfitSettingTypes(profitSettingTypeValue) {
        var retVal;

        var mapping = [];
        mapping[1] = ProfitSettingTypes.Flat; // maps to DealerFixedMarkup
        mapping[2] = ProfitSettingTypes.Percentage; // maps to DealerVariableMarkup
        mapping[3] = ProfitSettingTypes.Fixed; // maps to DealerFixedRetail
        mapping[5] = ProfitSettingTypes.StateRegulated; // maps to StateRegulatedRetailForced
        if(isFinite(profitSettingTypeValue)) {
            retVal = mapping[profitSettingTypeValue];
        } else {
            retVal = mapping.indexOf(profitSettingTypeValue);
        }

        return retVal;
    }

    ProfitSetting.prototype.populateDataFromBusinessSvcs = function(data) {
        this.type = mapProfitSettingTypes(data.ProfitMode);
        this._vehicleOverrideType = mapProfitSettingTypes(data.ProfitModeVehiclePriceOverride);
        this.mapProfitAmountFieldsFromSvc(data);
        this.productData = data.Product;
    };

    ProfitSetting.prototype.mapProfitAmountFieldsFromSvc= function(data) {
        switch(this.type) {
            case ProfitSettingTypes.Flat : {
                this._profitAmount = data.ProfitAmount;
                this._percentToCostCap = data.ProfitMaximumBound;
                break;
            }
            case ProfitSettingTypes.Fixed : {
                this._retailAmount = data.ProfitAmount;
                break;
            }
            case ProfitSettingTypes.Percentage : {
                this._percent = data.ProfitAmount;
                this._maxProfit = data.ProfitMaximumBound;
                break;
            }
        }
        if (data.BelowVehiclePriceOverride > 0) {
            this._vehicleOverridePurchasePrice = data.BelowVehiclePriceOverride;
            switch(this._vehicleOverrideType) {
                case ProfitSettingTypes.Flat : {
                    this._vehicleOverrideProfitAmount = data.ProfitAmountVehiclePriceOverride;
                    this._vehicleOverridePercentToCostCap = data.ProfitMaximumBoundVehiclePriceOverride;
                    break;
                }
                case ProfitSettingTypes.Fixed : {
                    this._vehicleOverrideRetailAmount = data.ProfitAmountVehiclePriceOverride;
                    break;
                }
                case ProfitSettingTypes.Percentage : {
                    this._vehicleOverridePercent = data.ProfitAmountVehiclePriceOverride;
                    this._vehicleOverrideMaxProfit = data.ProfitMaximumBoundVehiclePriceOverride;
                    break;
                }
            }
        } else {
            this._vehicleOverridePurchasePrice = 0;
        }
    };

    ProfitSetting.prototype.getSetProfitAmount = function(value) {
        if(angular.isDefined(value)) {
            if(this.type !== ProfitSettingTypes.Flat)
                throw { message : "Profit amount only applies to flat profit types." };
            if(!isFinite(Number(value)))
                throw { message : "Profit amount must be a numeric value." };
            this._profitAmount = value;
        } else {
            return getterHelper(this, ProfitSettingTypes.Flat,this._profitAmount);
        }
    };
    ProfitSetting.prototype.getSetOverrideProfitAmount = function(value) {
        if(angular.isDefined(value)) {
            if(this._vehicleOverrideType !== ProfitSettingTypes.Flat)
                throw { message : "Profit amount only applies to flat profit types." };
            if(!isFinite(Number(value)))
                throw { message : "Profit amount must be a numeric value." };
            this._vehicleOverrideProfitAmount = value;
        } else {
            return getterOverrideHelper(this, ProfitSettingTypes.Flat, this._vehicleOverrideProfitAmount);
        }
    };

    ProfitSetting.prototype.getSetPercentToCostCap = function(value) {
        if(angular.isDefined(value)) {
            if(this.type !== ProfitSettingTypes.Flat)
                throw { message : "Percent to cost cap only applies to flat profit types." };
            if(!isFinite(Number(value)))
                throw { message : "Percent to cost cap must be a number" };
            if(!isFinite(Number(value)))
                throw { message : "Percent to cost cap cannot be negative" };
            this._percentToCostCap = value;
        } else {
            return getterHelper(this, ProfitSettingTypes.Flat, this._percentToCostCap);
        }
    };

    ProfitSetting.prototype.getSetOverridePercentToCostCap = function(value) {
        if(angular.isDefined(value)) {
            if(this._vehicleOverrideType !== ProfitSettingTypes.Flat)
                throw { message : "Percent to cost cap only applies to flat profit types." };
            if(!isFinite(Number(value)))
                throw { message : "Percent to cost cap must be a number" };
            if(!isFinite(Number(value)))
                throw { message : "Percent to cost cap cannot be negative" };
            this._vehicleOverridePercentToCostCap = value;
        } else {
            return getterOverrideHelper(this, ProfitSettingTypes.Flat, this._vehicleOverridePercentToCostCap );
        }
    };

    ProfitSetting.prototype.getSetPercent = function(value) {
        if(angular.isDefined(value)) {
            if(this.type !== ProfitSettingTypes.Percentage)
                throw { message : "Percent only applies to percentage-based profit types." };
            if(!isFinite(Number(value)))
                throw { message : "Profit percent must be a number" };
            if(!isFinite(Number(value)))
                throw { message : "Profit percent cannot be negative" };
            this._percent = value;
        } else {
            return getterHelper(this, ProfitSettingTypes.Percentage, this._percent);
        }
    };

    ProfitSetting.prototype.getSetOverridePercent = function(value) {
        if(angular.isDefined(value)) {
            if(this._vehicleOverrideType !== ProfitSettingTypes.Percentage)
                throw { message : "Percent only applies to percentage-based profit types." };
            if(!isFinite(Number(value)))
                throw { message : "Profit percent must be a number" };
            if(!isFinite(Number(value)))
                throw { message : "Profit percent cannot be negative" };
            this._vehicleOverridePercent = value;
        } else {
            return getterOverrideHelper(this, ProfitSettingTypes.Percentage, this._vehicleOverridePercent);
        }
    };

    ProfitSetting.prototype.getSetMaxProfit = function(value) {
        if(angular.isDefined(value)) {
            if(this.type !== ProfitSettingTypes.Percentage)
                throw { message : "Max profit only applies to percentage-based profit types."};
            if(!isFinite(Number(value)))
                throw { message : "Max profit amount must be a numeric value."};
            this._maxProfit = value;
        } else {
            return getterHelper(this, ProfitSettingTypes.Percentage, this._maxProfit);
        }
    };

    ProfitSetting.prototype.getSetOverrideMaxProfit = function(value) {
        if(angular.isDefined(value)) {
            if(this._vehicleOverrideType !== ProfitSettingTypes.Percentage)
                throw { message : "Max profit only applies to percentage-based profit types."};
            if(!isFinite(Number(value)))
                throw { message : "Max profit amount must be a numeric value."};
            this._vehicleOverrideMaxProfit = value;
        } else {
            return getterOverrideHelper(this, ProfitSettingTypes.Percentage, this._vehicleOverrideMaxProfit);
        }
    };
    ProfitSetting.prototype.getSetRetailAmount = function(value) {
        if(angular.isDefined(value)) {
            if(this.type !== ProfitSettingTypes.Fixed)
                throw { message : "Retail amount only applies to fixed profit types."};
            if(!isFinite(Number(value)))
                throw { message : "Retail amount must be a numeric value."};
            this._retailAmount = value;
        } else {
            return getterHelper(this, ProfitSettingTypes.Fixed, this._retailAmount);
        }
    };

    ProfitSetting.prototype.getSetOverrideRetailAmount = function(value) {
        if(angular.isDefined(value)) {
            if(this._vehicleOverrideType !== ProfitSettingTypes.Fixed)
                throw { message : "Retail amount only applies to fixed profit types."};
            if(!isFinite(Number(value)))
                throw { message : "Retail amount must be a numeric value."};
            this._vehicleOverrideRetailAmount = value;
        } else {
            return getterOverrideHelper(this, ProfitSettingTypes.Fixed, this._vehicleOverrideRetailAmount);
        }
    };

    ProfitSetting.prototype.getSetOverridePurchasePrice = function(value) {
        if(angular.isDefined(value)) {
            if(!isFinite(Number(value)))
                throw { message : "Purchase price must be a numeric value."};
            this._vehicleOverridePurchasePrice = value;
        } else {
            return getterOverrideHelper(this, null, this._vehicleOverridePurchasePrice);
        }
    };

    ProfitSetting.prototype.toDisplayString = function()
    {
        switch (this.type) {
            case ProfitSettingTypes.Flat:
                return "FLAT: $" + this._profitAmount + " / " + this._percentToCostCap + "% max";

            case ProfitSettingTypes.Fixed:
                return "FIXED RETAIL: $" + this._retailAmount;

            case ProfitSettingTypes.Percentage:
                return "PERCENT: " + this._percent + "% / $" + this._maxProfit + " max";

            case ProfitSettingTypes.StateRegulated:
                return "STATE REGULATED";
        }
        return "";
    }

    ProfitSetting.prototype.toOverrideDisplayString = function()
    {
        switch (this._vehicleOverrideType) {
            case ProfitSettingTypes.Flat:
                return "FLAT: $" + this._vehicleOverrideProfitAmount + " / " + this._vehicleOverridePercentToCostCap + "% max";

            case ProfitSettingTypes.Fixed:
                return "FIXED RETAIL: $" + this._vehicleOverrideRetailAmount;

            case ProfitSettingTypes.Percentage:
                return "PERCENT: " + this._vehicleOverridePercent + "% / $" + this._vehicleOverrideMaxProfit + " max";

        }
        return "";
    }

    var getterHelper = function(obj, type, value) {
        if(obj.type !== type) {
            return undefined;
        } else {
            return value;
        }
    };
    var getterOverrideHelper = function(obj, type, value) {
        if(type && obj._vehicleOverrideType !== type) {
            return undefined;
        } else {
            return value;
        }
    };

    // this is "private" class used for formatting the data correctly to set it in business services
    var SPANProfitSetting = function() {
        // currently, none of the following data is actually saved in the business services. If problems arise saving a profit setting,
        // check to make sure that hasn't changed in the SaveProfitSettings endpoint. The data is *required* to make
        // the WCF endpoint recognize the call, however.
        this.ID = -2147483648;
        this.StartDate = '/Date(-62135575200000-0600)/';
        this.EndDate = null;
        this.RateVersionCode = null;
        this.RateVersionId = null;
        this.ProfitMode = null;
        this.ProfitModeDesc = '';
        this.ProfitMinimumBound = 0;
        this.ProfitAmount = 0;
        this.ProfitMaximumBound = 0;

        this.ProfitModeVehiclePriceOverride = null;
        this.ProfitAmountVehiclePriceOverride = 0;
        this.ProfitMinimumBoundVehiclePriceOverride = 0;
        this.ProfitMaximumBoundVehiclePriceOverride = 0;
        this.BelowVehiclePriceOverride = 0;
    };

    SPANProfitSetting.prototype.mapProfitAmountFieldsToSvc = function(profitSetting) {
        switch(profitSetting.type) {
            case ProfitSettingTypes.Flat : {
                this.ProfitAmount = Number(profitSetting._profitAmount);
                this.ProfitMaximumBound = Number(profitSetting._percentToCostCap);

                break;
            }
            case ProfitSettingTypes.Fixed : {
                this.ProfitAmount = Number(profitSetting._retailAmount);
                this.ProfitMaximumBound = 0;

                break;
            }
            case ProfitSettingTypes.Percentage : {
                this.ProfitAmount = Number(profitSetting._percent);
                this.ProfitMaximumBound = Number(profitSetting._maxProfit);

                break;
            }
        }
        if (profitSetting._vehicleOverridePurchasePrice > 0) {
            this.BelowVehiclePriceOverride = profitSetting._vehicleOverridePurchasePrice;
            switch(profitSetting._vehicleOverrideType) {
                case ProfitSettingTypes.Flat : {
                    this.ProfitAmountVehiclePriceOverride = Number(profitSetting._vehicleOverrideProfitAmount);
                    this.ProfitMaximumBoundVehiclePriceOverride = Number(profitSetting._vehicleOverridePercentToCostCap);
    
                    break;
                }
                case ProfitSettingTypes.Fixed : {
                    this.ProfitAmountVehiclePriceOverride = Number(profitSetting._vehicleOverrideRetailAmount);
                    this.ProfitMaximumBoundVehiclePriceOverride = 0;
    
                    break;
                }
                case ProfitSettingTypes.Percentage : {
                    this.ProfitAmountVehiclePriceOverride = Number(profitSetting._vehicleOverridePercent);
                    this.ProfitMaximumBoundVehiclePriceOverride = Number(profitSetting._vehicleOverrideMaxProfit);
    
                    break;
                }
            }            
        }
    };

    return ProfitSetting;
}]);

dealershipModule.factory('ProfitSettingTypes', function(){
    return {
        Flat : "Flat",
        Fixed : "Fixed",
        Percentage : "Percentage",
        StateRegulated : "StateRegulated"
    };
});